import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { TeamRankingQuery } from '../types';

/**
 * typeguard for TeamRanking
 * @param TeamRanking object passed to transformer
 */
export const isValidTeamRanking = (obj: TeamRankingQuery): boolean => Boolean(obj?.data?.getTeamRanking && !isEmptyObject(obj.data.getTeamRanking));
